





































































































import moment from 'moment'

import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { Component, Emit, Model, Prop, Vue, Watch } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { InvoiceFilters, InvoiceStatus, PaymentMethodEnum } from '@/models'

import { isSetsEqual, normalizeDate } from '@/utils'

interface DateOptions {
  max?: string | null
  min?: string | null
}

@Component({
  components: {
    ListItem,
    ValidationObserver,
    ValidationProvider
  }
})
export default class InvoiceFiltersForm extends Vue {
  @Model('change', { type: Object, default: null })
  readonly data!: InvoiceFilters | null

  @Prop({ type: Object, required: true })
  readonly initialFilters!: InvoiceFilters

  isValid = false

  fromDate = ''

  fromDateOptions: DateOptions = {
    max: moment().format('YYYY-MM-DD')
  }

  untilDate = ''

  untilDateOptions: DateOptions = {
    min: null,
    max: moment().format('YYYY-MM-DD')
  }

  invoiceStatus: [InvoiceStatus, boolean][] = [
    [InvoiceStatus.OPEN, false],
    [InvoiceStatus.CLOSING, false],
    [InvoiceStatus.CLOSED, false],
    [InvoiceStatus.CANCELED, false]
  ]

  InvoiceStatusTexts: Record<InvoiceStatus, string> = {
    [InvoiceStatus.OPEN]: 'Em aberto',
    [InvoiceStatus.CLOSING]: 'Encerrado',
    [InvoiceStatus.CLOSED]: 'Confirmado',
    [InvoiceStatus.CANCELED]: 'Cancelado'
  }

  paymentMethod: [PaymentMethodEnum, boolean][] = [
    [PaymentMethodEnum.CASH, false],
    [PaymentMethodEnum.CREDIT_CARD, false],
    [PaymentMethodEnum.DEBIT_CARD, false],
    [PaymentMethodEnum.ONLINE, false]
  ]

  PaymentMethodTexts: Record<PaymentMethodEnum, string> = {
    [PaymentMethodEnum.CASH]: 'Dinheiro',
    [PaymentMethodEnum.CREDIT_CARD]: 'Cartão de crédito',
    [PaymentMethodEnum.DEBIT_CARD]: 'Cartão de débito',
    [PaymentMethodEnum.ONLINE]: 'Online'
  }

  get enabledInvoiceStatus () {
    return this.invoiceStatus
      .filter((entry) => entry[1])
      .map((entry) => entry[0])
  }

  get enabledPaymentMethod () {
    return this.paymentMethod
      .filter((entry) => entry[1])
      .map((entry) => entry[0])
  }

  get isFormValid () {
    return this.isValid && (this.enabledInvoiceStatus.length > 0 || this.enabledPaymentMethod.length > 0)
  }

  get isOpenChecked () {
    return this.invoiceStatus[0][1]
  }

  @Watch('data')
  onDataChange (filters: InvoiceFilters) {
    this.updateFields(filters)
  }

  @Watch('fromDate')
  onFromDateChange (value: string) {
    const date = normalizeDate(value)

    this.untilDateOptions.min = date

    this.updateModel()
  }

  @Watch('untilDate')
  onUntilDateChange (value: string) {
    const date = normalizeDate(value)

    this.fromDateOptions.max = date ?? this.untilDateOptions.max

    this.updateModel()
  }

  @Watch('invoiceStatus')
  onInvoiceStatusChange () {
    this.updateModel()
  }

  @Watch('paymentMethod')
  onPaymentMethodChange () {
    this.updateModel()
  }

  @Watch('isFormValid')
  onIsFormValidChange () {
    this.$emit('update:isValid', this.isFormValid)
  }

  created () {
    this.updateFields(this.initialFilters)
  }

  updateFields (filters: InvoiceFilters) {
    this.fromDate = filters.from ?? ''
    this.untilDate = filters.until ?? ''

    const statusFilter = filters.status ?? []
    const paymentMethodFilter = filters.paymentMethods ?? []

    if (!isSetsEqual(new Set(this.enabledInvoiceStatus), new Set(statusFilter))) {
      this.invoiceStatus = this.invoiceStatus
        .map((entry) => [entry[0], statusFilter.includes(entry[0])])
    }

    if (!isSetsEqual(new Set(this.enabledPaymentMethod), new Set(paymentMethodFilter))) {
      this.paymentMethod = this.paymentMethod
        .map((entry) => [entry[0], paymentMethodFilter.includes(entry[0])])
    }
  }

  /**
   * This is a hack because ValidationObserver does not emit a status event
   * and its validate() method returns a Promise.
   */
  setIsValid (valid: boolean) {
    this.isValid = valid
  }

  @Emit('change')
  updateModel (): InvoiceFilters {
    return {
      from: this.fromDate || undefined,
      until: this.untilDate || undefined,
      status: this.enabledInvoiceStatus,
      paymentMethods: this.enabledPaymentMethod
    }
  }

  submit () {
    if (this.isFormValid) {
      this.$emit('submit')
    }
  }
}
